/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletHIcon20Regular = forwardRef('TechScreenTabletHIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.75 12.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.249 3.001a3.25 3.25 0 0 0-3.25 3.25v7.5a3.25 3.25 0 0 0 3.25 3.25h9.5a3.25 3.25 0 0 0 3.25-3.25v-7.5a3.25 3.25 0 0 0-3.25-3.25h-9.5Zm-1.75 3.25c0-.966.783-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v7.5a1.75 1.75 0 0 1-1.75 1.75h-9.5a1.75 1.75 0 0 1-1.75-1.75v-7.5Z" })));
});
